export function normalizeFeeValue(value) {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value === 'bigint') return null;
  if (typeof value !== 'string') return null;
  const text = value.trim();
  if (!/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/.test(text)) return null;
  const parsed = Number(text);
  return Number.isFinite(parsed) ? parsed : null;
}

export function normalizeFeeRow(row, fields) {
  const normalized = { ...row };
  for (const field of fields) normalized[field] = normalizeFeeValue(row[field]);
  normalized.total = normalizeFeeValue(row.total);
  return normalized;
}

export function normalizeFeeRows(rows, fields) {
  return (Array.isArray(rows) ? rows : []).map((row) => normalizeFeeRow(row, fields));
}

export function compareFeeTotals(a, b) {
  const left = normalizeFeeValue(a && a.total);
  const right = normalizeFeeValue(b && b.total);
  if (left === null && right === null) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  return right - left;
}

export function formatFeePercent(value) {
  const normalized = normalizeFeeValue(value);
  const percent = normalized === null ? null : normalized * 100;
  return percent === null || !Number.isFinite(percent) ? '缺失/未核实' : `${percent.toFixed(3)}%`;
}
